const DEFAULT_ROBOTS = 'index, follow'

export const useRobotsMeta = (source: () => string[] | string | null | undefined) => {
	return computed(() => {
		const robots = source()
		if (!robots || robots.length === 0) return DEFAULT_ROBOTS
		return Array.isArray(robots) ? robots.join(', ') : robots
	})
}
